import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useArticleDateUtils } from "~/components/article/article-author-block/article-date/hooks";
import type { defaultArticleDateContent$key } from "~/queries/__generated__/defaultArticleDateContent.graphql";

import { PublishedDateContainer, StyledDiv, UpdatedDateContainer } from "./styles";

export type Props = {
  reference: defaultArticleDateContent$key;
};

export const DefaultArticleDate: FunctionComponent<Props> = ({
  reference: reference_,
  ...attribs
}) => {
  const content = useFragment(
    graphql`
      fragment defaultArticleDateContent on Content {
        ...hooksArticleDateUtilsContent
      }
    `,
    reference_,
  );
  const [isToggle, setToggle] = useToggle(false);

  const { isoPublishedDate, isoUpdatedDate, lastUpdatedDate, publishedDate } =
    useArticleDateUtils(content);

  if (!content) return null;

  return (
    <StyledDiv onClick={setToggle} {...attribs}>
      <PublishedDateContainer $isToggle={isToggle}>
        <time dateTime={isoPublishedDate}>Published: {publishedDate}</time>
      </PublishedDateContainer>
      {isToggle && isoUpdatedDate && (
        <UpdatedDateContainer>
          <time dateTime={isoUpdatedDate}>Updated: {lastUpdatedDate}</time>
        </UpdatedDateContainer>
      )}
    </StyledDiv>
  );
};

DefaultArticleDate.displayName = "DefaultArticleDate";
